import { axiosInstanceIservices } from 'lib/services/config/axios-config'
import { TemporaryCredentials, TRestResponse } from '../restApi.types'
import { useQuery } from 'react-query'

const getTranscribeCredentials = async (): Promise<
  TRestResponse<TemporaryCredentials>
> => {
  try {
    const { data: responseData } = await axiosInstanceIservices.get<
      TRestResponse<TemporaryCredentials>
    >(`/transcribe/credentials`)
    return responseData
  } catch (error) {
    console.error(error)
    return {
      success: false,
      message: (error as Error).message,
    }
  }
}

export const useGetTranscribeCredentials = () => {
  return useQuery({
    queryKey: ['transcribeCredentials'],
    queryFn: () => getTranscribeCredentials(),
  })
}
